import { BetLoopKambiShareCoupon } from "@core/Areas/BetLoop/types";
import { KambiHistoryCoupon } from "@mobi/api-types/kambi";

export const getLegsProgressOutcomes = (
  historyCoupon: KambiHistoryCoupon | BetLoopKambiShareCoupon
): KambiHistoryCoupon['outcomes'] => {
  return historyCoupon.bets[0].couponRowIndexes
    .map(idx => historyCoupon.couponRows[idx])
    .flatMap(orderLegsStatusOutcomesByCouponRow(historyCoupon))
}

// =============
// Local Helpers
// =============

const orderLegsStatusOutcomesByCouponRow =
  (historyCoupon: KambiHistoryCoupon | BetLoopKambiShareCoupon) =>
  (couponRow: KambiHistoryCoupon['couponRows'][number]) => {
    if (couponRow.selectionType === 'BET_BUILDER' && couponRow.outcomeGroup) {
      const firstOutcomeId = couponRow.outcomeGroup.groups[0]?.outcomeIds[0]
      const outcome = historyCoupon.outcomes.find(o => o.outcomeId === firstOutcomeId)
      return outcome ? [outcome] : []
    }

    const outcome = historyCoupon.outcomes.find(o => o.outcomeId === couponRow.outcomeId)
    return outcome ? [outcome] : []
  }
